import { SXStyleSheet } from '@/utils';

const style = SXStyleSheet.create({
  text: {
    textDecorationLine: 'underline',
    cursor: 'pointer',
  },
  textVariants: {
    // Design-Rollout: hoechstens 14 (Rollen 14/12), vorher 16.
    large: {
      fontSize: '14px',
    },
    small: {
      fontSize: '12px',
    },
    medium: {
      fontSize: '14px',
    },
  },
});

export default style;
